import reportError from '../ErrorReporting/reportError';

const retry = <Value>(fn: () => Promise<Value>, retriesLeft = 5, interval = 1000): Promise<Value> =>
  new Promise((resolve, reject) =>
    fn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 0) {
          reportError(error);
          reject(error);
          return;
        }

        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      })
  );

export default retry;
